import './ProviderDataStyle.css';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

export default function HYCOM() {
  return (
    <>
      <div className="dialogWarning">
        MIKE Data Link carries out comprehensive quality control checks on all third-party datasets.
        However, errors and inconsistencies inherited from these datasets (for example, missing
        values) may appear as errors in extracted data. If you encounter incorrect values such as
        NaN or erroneous zero values in extracted boundary conditions, initial conditions, or
        forcings output files, please contact{' '}
        <a href="mailto:mike@dhigroup.com">mike@dhigroup.com.</a>
      </div>
      <div className="dialogSummary">
        The data set from HYCOM (HYbrid Coordinate Ocean Model) include global-scale ocean model
        data. HYCOM is a consortium of multi-institutional effort sponsored by the National Ocean
        Partnership Program (NOPP), as part of the U. S. Global Ocean Data Assimilation Experiment
        (GODAE), to develop and evaluate a data-assimilative hybrid coordinate ocean model.
      </div>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              General
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>HYCOM Global Ocean Forecasting System (GOFS) version 3.1</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Coverage</TableCell>
            <TableCell>Global</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Category</TableCell>
            <TableCell>Ocean Parameters</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Source Name</TableCell>
            <TableCell>
              HYCOM GOFS 3.1 <br /> Datasets: GLBy0.08 and GLBv0.08
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Publisher</TableCell>
            <TableCell>The HYCOM consortium for Data Assimilative Modelling</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Cost (ex. VAT)</TableCell>
            <TableCell>Free</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Typical Applications</TableCell>
            <TableCell>Hydrodynamic, Offshore and Marine projects</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>References</TableCell>
            <TableCell>
              <a href="https://www.hycom.org/" target="_blank" rel="noopener noreferrer">
                HYCOM home
              </a>
              <br />
              <a
                href="https://www.hycom.org/dataserver/gofs-3pt1/analysis"
                target="_blank"
                rel="noopener noreferrer">
                GOFS 3.1 main page
              </a>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Coverage
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Geographical Range</TableCell>
            <TableCell>
              Global:
              <br />
              Longitude: 180°W -&gt; 180°E
              <br />
              Latitude: 80°S -&gt; 90°N
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Resolution</TableCell>
            <TableCell>
              GLBy0.08: <br />
              0.08 deg. Long x 0.04 deg. Lat
              <br />
              <br />
              GLBv0.08: <br />
              0.08 deg. Long x 0.08 deg. Lat between 40S-40N. <br />
              0.04 deg. Long x 0.04 deg. Lat poleward of 40S/40N
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Reference</TableCell>
            <TableCell>Sea surface</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Range</TableCell>
            <TableCell>Sea surface to Sea bed</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Resolution</TableCell>
            <TableCell>41 layers</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Reference</TableCell>
            <TableCell>UTC</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Range</TableCell>
            <TableCell>
              Data Link coverage:
              <br />
              GLBy0.08: 93: 4/12-2018 -&gt; Present
              <br />
              GLBv0.08: 93: 27/11-2018 -&gt; 3/12-2018
              <br />
              GLBa0.08: 91.2: 18/4-2016 -&gt; 26/11-2018
              <br />
              GLBa0.08: 91.1: 5/4-2014 -&gt; 18/4-2016
              <br />
              GLBa0.08: 91: 21/8-2013 -&gt; 4/4-2014
              <br />
              GLBa0.08: 90.9: 3/1-2011 -&gt; 20/8-2014
              <br />
              GLBa0.08: 90.8: 7/5-2009 -&gt; 2/11-2011
              <br />
              GLBa0.08: 90.6: 19/9-2008 -&gt; 6/5-2009
              <br />
              GLBa0.08: 90.3: 27/4-2007 -&gt; 18/9-2007
              <br />
              GLBa0.08: 90.2: 1/1-2007 -&gt; 26/4-2007
              <br />
              GLBa0.08: 60.5: 3/11-2003 -&gt; 31/12-2006
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Resolution</TableCell>
            <TableCell>3-hourly</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Variables
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Name (Unit)</TableCell>
            <TableCell>
              Sea Surface Height [m]
              <br />
              Water Temperature [deg C]
              <br />
              Salinity [psu]
              <br />
              U-velocity component (East dir.) [m/s]
              <br />
              V-velocity component (North dir.) [m/s]
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Credits
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Data product Authors and Originators</TableCell>
            <TableCell>
              DOC/NOAA/NWS/NCEP &gt; National Centers for Environmental Prediction, National Weather
              Service, NOAA, U.S. Department of Commerce
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Data product Publisher</TableCell>
            <TableCell>
              NOAA National Centers for Environmental Information. DOC/NOAA/NESDIS/NCDC &gt;
              National Climatic Data Center, NESDIS, NOAA, U.S. Department of Commerce
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
}
